/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Fluence API
 * Personal liquidity planning.
 *
 * This document is generated from the WebFlux controllers and their springdoc annotations. Do not edit it by hand — regenerate it with `mvn verify`.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Account,
  AccountInput,
  BalanceAnchor,
  BalanceAnchorInput,
  BankConnection,
  Calendar,
  CandidateAccount,
  CashFlow,
  CashFlowInput,
  ConsumerLoan,
  ConsumerLoanInput,
  CreditCard,
  CreditCardInput,
  EstablishedConnection,
  GetProjectionParams,
  Health,
  ImportSelection,
  ImportSummary,
  LinkSession,
  Me,
  Projection,
  PublicTokenInput,
  Reconciliation,
  Recording,
  RecordingInput
} from './model';

import { http } from '../http';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listAccountsResponse200 = {
  data: Account[]
  status: 200
}

export type listAccountsResponseSuccess = (listAccountsResponse200) & {
  headers: Headers;
};
;

export type listAccountsResponse = (listAccountsResponseSuccess)

export const getListAccountsUrl = () => {




  return `/api/accounts`
}

/**
 * Each entry carries what depends on it, so the UI can say what deleting would destroy before asking for confirmation.
 * @summary List accounts
 */
export const listAccounts = async ( options?: Parameters<typeof http>[1]): Promise<listAccountsResponse> => {

  return http<listAccountsResponse>(getListAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccountsQueryKey = () => {
    return [
    `/api/accounts`
    ] as const;
    }


export const getListAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listAccounts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccounts>>> = ({ signal }) => listAccounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccounts>>>
export type ListAccountsQueryError = unknown


export function useListAccounts<TData = Awaited<ReturnType<typeof listAccounts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccounts>>,
          TError,
          Awaited<ReturnType<typeof listAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAccounts<TData = Awaited<ReturnType<typeof listAccounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccounts>>,
          TError,
          Awaited<ReturnType<typeof listAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAccounts<TData = Awaited<ReturnType<typeof listAccounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List accounts
 */

export function useListAccounts<TData = Awaited<ReturnType<typeof listAccounts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccounts>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAccountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createAccountResponse201 = {
  data: Account[]
  status: 201
}

export type createAccountResponse400 = {
  data: void
  status: 400
}

export type createAccountResponse409 = {
  data: void
  status: 409
}

export type createAccountResponseSuccess = (createAccountResponse201) & {
  headers: Headers;
};
export type createAccountResponseError = (createAccountResponse400 | createAccountResponse409) & {
  headers: Headers;
};

export type createAccountResponse = (createAccountResponseSuccess | createAccountResponseError)

export const getCreateAccountUrl = () => {




  return `/api/accounts`
}

/**
 * An opening balance is required and is written in the same transaction. A projection cannot run for an account with no observed balance, so an account without one would not merely be incomplete — it would break every projection.
 * @summary Create an account
 */
export const createAccount = async (accountInput: AccountInput, options?: Parameters<typeof http>[1]): Promise<createAccountResponse> => {

  return http<createAccountResponse>(getCreateAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(accountInput)
  }
);}





export const getCreateAccountMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: AccountInput}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: AccountInput}, TContext> => {

const mutationKey = ['createAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccount>>, {data: AccountInput}> = (props) => {
          const {data} = props ?? {};

          return  createAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createAccount>>>
    export type CreateAccountMutationBody = AccountInput
    export type CreateAccountMutationError = void

    /**
 * @summary Create an account
 */
export const useCreateAccount = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: AccountInput}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAccount>>,
        TError,
        {data: AccountInput},
        TContext
      > => {
      return useMutation(getCreateAccountMutationOptions(options), queryClient);
    }

export type deleteAccountResponse204 = {
  data: void
  status: 204
}

export type deleteAccountResponse400 = {
  data: void
  status: 400
}

export type deleteAccountResponse404 = {
  data: void
  status: 404
}

export type deleteAccountResponseSuccess = (deleteAccountResponse204) & {
  headers: Headers;
};
export type deleteAccountResponseError = (deleteAccountResponse400 | deleteAccountResponse404) & {
  headers: Headers;
};

export type deleteAccountResponse = (deleteAccountResponseSuccess | deleteAccountResponseError)

export const getDeleteAccountUrl = (id: string,) => {




  return `/api/accounts/${id}`
}

/**
 * Cash flows, loans, balance anchors and recordings on this account are removed with it. Refused while a card is paid from it: clearing that link would turn an auto-paid card into a manually paid one and silently drop an obligation from the projection.
 * @summary Delete an account and everything that depends on it
 */
export const deleteAccount = async (id: string, options?: Parameters<typeof http>[1]): Promise<deleteAccountResponse> => {

  return http<deleteAccountResponse>(getDeleteAccountUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAccountMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccount>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccount>>>

    export type DeleteAccountMutationError = void

    /**
 * @summary Delete an account and everything that depends on it
 */
export const useDeleteAccount = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccount>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteAccountMutationOptions(options), queryClient);
    }

export type updateAccountResponse200 = {
  data: Account[]
  status: 200
}

export type updateAccountResponse400 = {
  data: void
  status: 400
}

export type updateAccountResponse404 = {
  data: void
  status: 404
}

export type updateAccountResponseSuccess = (updateAccountResponse200) & {
  headers: Headers;
};
export type updateAccountResponseError = (updateAccountResponse400 | updateAccountResponse404) & {
  headers: Headers;
};

export type updateAccountResponse = (updateAccountResponseSuccess | updateAccountResponseError)

export const getUpdateAccountUrl = (id: string,) => {




  return `/api/accounts/${id}`
}

/**
 * Name, buffer and interest terms only. Currency and type are fixed once set: changing a currency would invalidate every amount already recorded against the account, and there is no honest conversion.
 * @summary Update an account
 */
export const updateAccount = async (id: string,
    accountInput: AccountInput, options?: Parameters<typeof http>[1]): Promise<updateAccountResponse> => {

  return http<updateAccountResponse>(getUpdateAccountUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(accountInput)
  }
);}





export const getUpdateAccountMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{id: string;data: AccountInput}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{id: string;data: AccountInput}, TContext> => {

const mutationKey = ['updateAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccount>>, {id: string;data: AccountInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAccount(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccount>>>
    export type UpdateAccountMutationBody = AccountInput
    export type UpdateAccountMutationError = void

    /**
 * @summary Update an account
 */
export const useUpdateAccount = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{id: string;data: AccountInput}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAccount>>,
        TError,
        {id: string;data: AccountInput},
        TContext
      > => {
      return useMutation(getUpdateAccountMutationOptions(options), queryClient);
    }

export type listAnchorsResponse200 = {
  data: BalanceAnchor[]
  status: 200
}

export type listAnchorsResponseSuccess = (listAnchorsResponse200) & {
  headers: Headers;
};
;

export type listAnchorsResponse = (listAnchorsResponseSuccess)

export const getListAnchorsUrl = () => {




  return `/api/anchors`
}

/**
 * @summary List observed balances, most recent first
 */
export const listAnchors = async ( options?: Parameters<typeof http>[1]): Promise<listAnchorsResponse> => {

  return http<listAnchorsResponse>(getListAnchorsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAnchorsQueryKey = () => {
    return [
    `/api/anchors`
    ] as const;
    }


export const getListAnchorsQueryOptions = <TData = Awaited<ReturnType<typeof listAnchors>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnchors>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnchorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnchors>>> = ({ signal }) => listAnchors({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAnchors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAnchorsQueryResult = NonNullable<Awaited<ReturnType<typeof listAnchors>>>
export type ListAnchorsQueryError = unknown


export function useListAnchors<TData = Awaited<ReturnType<typeof listAnchors>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnchors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnchors>>,
          TError,
          Awaited<ReturnType<typeof listAnchors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnchors<TData = Awaited<ReturnType<typeof listAnchors>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnchors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnchors>>,
          TError,
          Awaited<ReturnType<typeof listAnchors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnchors<TData = Awaited<ReturnType<typeof listAnchors>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnchors>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List observed balances, most recent first
 */

export function useListAnchors<TData = Awaited<ReturnType<typeof listAnchors>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnchors>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAnchorsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type setAnchorResponse200 = {
  data: BalanceAnchor[]
  status: 200
}

export type setAnchorResponse400 = {
  data: void
  status: 400
}

export type setAnchorResponseSuccess = (setAnchorResponse200) & {
  headers: Headers;
};
export type setAnchorResponseError = (setAnchorResponse400) & {
  headers: Headers;
};

export type setAnchorResponse = (setAnchorResponseSuccess | setAnchorResponseError)

export const getSetAnchorUrl = () => {




  return `/api/anchors`
}

/**
 * Replaces any existing anchor for the same account and date — correcting today's balance twice is ordinary, and the second correction is the one you meant.
 * @summary Record an observed balance
 */
export const setAnchor = async (balanceAnchorInput: BalanceAnchorInput, options?: Parameters<typeof http>[1]): Promise<setAnchorResponse> => {

  return http<setAnchorResponse>(getSetAnchorUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(balanceAnchorInput)
  }
);}





export const getSetAnchorMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAnchor>>, TError,{data: BalanceAnchorInput}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof setAnchor>>, TError,{data: BalanceAnchorInput}, TContext> => {

const mutationKey = ['setAnchor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAnchor>>, {data: BalanceAnchorInput}> = (props) => {
          const {data} = props ?? {};

          return  setAnchor(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAnchorMutationResult = NonNullable<Awaited<ReturnType<typeof setAnchor>>>
    export type SetAnchorMutationBody = BalanceAnchorInput
    export type SetAnchorMutationError = void

    /**
 * @summary Record an observed balance
 */
export const useSetAnchor = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAnchor>>, TError,{data: BalanceAnchorInput}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAnchor>>,
        TError,
        {data: BalanceAnchorInput},
        TContext
      > => {
      return useMutation(getSetAnchorMutationOptions(options), queryClient);
    }

export type deleteAnchorResponse204 = {
  data: void
  status: 204
}

export type deleteAnchorResponse400 = {
  data: void
  status: 400
}

export type deleteAnchorResponse404 = {
  data: void
  status: 404
}

export type deleteAnchorResponseSuccess = (deleteAnchorResponse204) & {
  headers: Headers;
};
export type deleteAnchorResponseError = (deleteAnchorResponse400 | deleteAnchorResponse404) & {
  headers: Headers;
};

export type deleteAnchorResponse = (deleteAnchorResponseSuccess | deleteAnchorResponseError)

export const getDeleteAnchorUrl = (id: string,) => {




  return `/api/anchors/${id}`
}

/**
 * Refused if it is the account's last one: without an anchor there is no honest starting balance and the projection cannot run.
 * @summary Remove an observed balance
 */
export const deleteAnchor = async (id: string, options?: Parameters<typeof http>[1]): Promise<deleteAnchorResponse> => {

  return http<deleteAnchorResponse>(getDeleteAnchorUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAnchorMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnchor>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAnchor>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAnchor'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAnchor>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAnchor(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAnchorMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAnchor>>>

    export type DeleteAnchorMutationError = void

    /**
 * @summary Remove an observed balance
 */
export const useDeleteAnchor = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnchor>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAnchor>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteAnchorMutationOptions(options), queryClient);
    }

export type listConnectionsResponse200 = {
  data: BankConnection[]
  status: 200
}

export type listConnectionsResponseSuccess = (listConnectionsResponse200) & {
  headers: Headers;
};
;

export type listConnectionsResponse = (listConnectionsResponseSuccess)

export const getListConnectionsUrl = () => {




  return `/api/bank/connections`
}

/**
 * @summary List linked banks
 */
export const listConnections = async ( options?: Parameters<typeof http>[1]): Promise<listConnectionsResponse> => {

  return http<listConnectionsResponse>(getListConnectionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConnectionsQueryKey = () => {
    return [
    `/api/bank/connections`
    ] as const;
    }


export const getListConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof listConnections>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConnectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConnections>>> = ({ signal }) => listConnections({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listConnections>>>
export type ListConnectionsQueryError = unknown


export function useListConnections<TData = Awaited<ReturnType<typeof listConnections>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnections>>,
          TError,
          Awaited<ReturnType<typeof listConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConnections<TData = Awaited<ReturnType<typeof listConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnections>>,
          TError,
          Awaited<ReturnType<typeof listConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConnections<TData = Awaited<ReturnType<typeof listConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List linked banks
 */

export function useListConnections<TData = Awaited<ReturnType<typeof listConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListConnectionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type completeLinkResponse201 = {
  data: EstablishedConnection
  status: 201
}

export type completeLinkResponse400 = {
  data: void
  status: 400
}

export type completeLinkResponseSuccess = (completeLinkResponse201) & {
  headers: Headers;
};
export type completeLinkResponseError = (completeLinkResponse400) & {
  headers: Headers;
};

export type completeLinkResponse = (completeLinkResponseSuccess | completeLinkResponseError)

export const getCompleteLinkUrl = () => {




  return `/api/bank/connections`
}

/**
 * Exchanges the widget's public token for a durable credential, stores it encrypted, and reports the accounts behind it. Imports nothing: which accounts belong in a plan is the user's decision, and a joint account, a dormant one or a child's savings are all things somebody may reasonably not want. Call the import endpoint with a selection. Re-linking the same institution updates the existing connection rather than adding a second.
 * @summary Complete a bank login
 */
export const completeLink = async (publicTokenInput: PublicTokenInput, options?: Parameters<typeof http>[1]): Promise<completeLinkResponse> => {

  return http<completeLinkResponse>(getCompleteLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(publicTokenInput)
  }
);}





export const getCompleteLinkMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeLink>>, TError,{data: PublicTokenInput}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof completeLink>>, TError,{data: PublicTokenInput}, TContext> => {

const mutationKey = ['completeLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeLink>>, {data: PublicTokenInput}> = (props) => {
          const {data} = props ?? {};

          return  completeLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteLinkMutationResult = NonNullable<Awaited<ReturnType<typeof completeLink>>>
    export type CompleteLinkMutationBody = PublicTokenInput
    export type CompleteLinkMutationError = void

    /**
 * @summary Complete a bank login
 */
export const useCompleteLink = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeLink>>, TError,{data: PublicTokenInput}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeLink>>,
        TError,
        {data: PublicTokenInput},
        TContext
      > => {
      return useMutation(getCompleteLinkMutationOptions(options), queryClient);
    }

export type removeConnectionResponse204 = {
  data: void
  status: 204
}

export type removeConnectionResponse404 = {
  data: void
  status: 404
}

export type removeConnectionResponseSuccess = (removeConnectionResponse204) & {
  headers: Headers;
};
export type removeConnectionResponseError = (removeConnectionResponse404) & {
  headers: Headers;
};

export type removeConnectionResponse = (removeConnectionResponseSuccess | removeConnectionResponseError)

export const getRemoveConnectionUrl = (id: string,) => {




  return `/api/bank/connections/${id}`
}

/**
 * Revokes the credential at the provider as well as deleting it here. Removing only our row would leave the consent standing, so a user who disconnected their bank would still be sharing it. Imported accounts and cash flows are kept — they are the user's data now, not the bank's.
 * @summary Disconnect a bank
 */
export const removeConnection = async (id: string, options?: Parameters<typeof http>[1]): Promise<removeConnectionResponse> => {

  return http<removeConnectionResponse>(getRemoveConnectionUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveConnectionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeConnection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof removeConnection>>, TError,{id: string}, TContext> => {

const mutationKey = ['removeConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeConnection>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  removeConnection(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof removeConnection>>>

    export type RemoveConnectionMutationError = void

    /**
 * @summary Disconnect a bank
 */
export const useRemoveConnection = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeConnection>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeConnection>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRemoveConnectionMutationOptions(options), queryClient);
    }

export type listCandidateAccountsResponse200 = {
  data: CandidateAccount[]
  status: 200
}

export type listCandidateAccountsResponse404 = {
  data: void
  status: 404
}

export type listCandidateAccountsResponseSuccess = (listCandidateAccountsResponse200) & {
  headers: Headers;
};
export type listCandidateAccountsResponseError = (listCandidateAccountsResponse404) & {
  headers: Headers;
};

export type listCandidateAccountsResponse = (listCandidateAccountsResponseSuccess | listCandidateAccountsResponseError)

export const getListCandidateAccountsUrl = (id: string,) => {




  return `/api/bank/connections/${id}/accounts`
}

/**
 * What the bank exposes, and which of them can join the plan.
 * @summary The accounts behind a connection
 */
export const listCandidateAccounts = async (id: string, options?: Parameters<typeof http>[1]): Promise<listCandidateAccountsResponse> => {

  return http<listCandidateAccountsResponse>(getListCandidateAccountsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCandidateAccountsQueryKey = (id: string,) => {
    return [
    `/api/bank/connections/${id}/accounts`
    ] as const;
    }


export const getListCandidateAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listCandidateAccounts>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidateAccounts>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCandidateAccountsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCandidateAccounts>>> = ({ signal }) => listCandidateAccounts(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCandidateAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCandidateAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listCandidateAccounts>>>
export type ListCandidateAccountsQueryError = void


export function useListCandidateAccounts<TData = Awaited<ReturnType<typeof listCandidateAccounts>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidateAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCandidateAccounts>>,
          TError,
          Awaited<ReturnType<typeof listCandidateAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCandidateAccounts<TData = Awaited<ReturnType<typeof listCandidateAccounts>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidateAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCandidateAccounts>>,
          TError,
          Awaited<ReturnType<typeof listCandidateAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCandidateAccounts<TData = Awaited<ReturnType<typeof listCandidateAccounts>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidateAccounts>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The accounts behind a connection
 */

export function useListCandidateAccounts<TData = Awaited<ReturnType<typeof listCandidateAccounts>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidateAccounts>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCandidateAccountsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type importConnectionResponse200 = {
  data: ImportSummary
  status: 200
}

export type importConnectionResponse404 = {
  data: void
  status: 404
}

export type importConnectionResponseSuccess = (importConnectionResponse200) & {
  headers: Headers;
};
export type importConnectionResponseError = (importConnectionResponse404) & {
  headers: Headers;
};

export type importConnectionResponse = (importConnectionResponseSuccess | importConnectionResponseError)

export const getImportConnectionUrl = (id: string,) => {




  return `/api/bank/connections/${id}/import`
}

/**
 * Creates an account and opening balance for each selected bank account, and a cash flow for each recurring payment confidently detected in its history. Eligible accounts left out of the selection are remembered as declined. Omit the selection to take everything eligible, which is also how a re-import picks up accounts opened since last time. Accounts already linked are never duplicated.
 * @summary Import accounts from a connection
 */
export const importConnection = async (id: string,
    importSelection?: ImportSelection, options?: Parameters<typeof http>[1]): Promise<importConnectionResponse> => {

  return http<importConnectionResponse>(getImportConnectionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importSelection)
  }
);}





export const getImportConnectionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importConnection>>, TError,{id: string;data?: ImportSelection}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof importConnection>>, TError,{id: string;data?: ImportSelection}, TContext> => {

const mutationKey = ['importConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importConnection>>, {id: string;data?: ImportSelection}> = (props) => {
          const {id,data} = props ?? {};

          return  importConnection(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof importConnection>>>
    export type ImportConnectionMutationBody = ImportSelection | undefined
    export type ImportConnectionMutationError = void

    /**
 * @summary Import accounts from a connection
 */
export const useImportConnection = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importConnection>>, TError,{id: string;data?: ImportSelection}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importConnection>>,
        TError,
        {id: string;data?: ImportSelection},
        TContext
      > => {
      return useMutation(getImportConnectionMutationOptions(options), queryClient);
    }

export type createLinkSessionResponse200 = {
  data: LinkSession
  status: 200
}

export type createLinkSessionResponseSuccess = (createLinkSessionResponse200) & {
  headers: Headers;
};
;

export type createLinkSessionResponse = (createLinkSessionResponseSuccess)

export const getCreateLinkSessionUrl = () => {




  return `/api/bank/link-session`
}

/**
 * Returns a short-lived token for the provider's widget. The user authenticates with their bank inside it, so no credential ever reaches Fluence.
 * @summary Start a bank login
 */
export const createLinkSession = async ( options?: Parameters<typeof http>[1]): Promise<createLinkSessionResponse> => {

  return http<createLinkSessionResponse>(getCreateLinkSessionUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateLinkSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLinkSession>>, TError,void, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof createLinkSession>>, TError,void, TContext> => {

const mutationKey = ['createLinkSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLinkSession>>, void> = () => {


          return  createLinkSession(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLinkSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createLinkSession>>>

    export type CreateLinkSessionMutationError = unknown

    /**
 * @summary Start a bank login
 */
export const useCreateLinkSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLinkSession>>, TError,void, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLinkSession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateLinkSessionMutationOptions(options), queryClient);
    }

export type listCalendarsResponse200 = {
  data: Calendar[]
  status: 200
}

export type listCalendarsResponseSuccess = (listCalendarsResponse200) & {
  headers: Headers;
};
;

export type listCalendarsResponse = (listCalendarsResponseSuccess)

export const getListCalendarsUrl = () => {




  return `/api/calendars`
}

/**
 * @summary List settlement calendars
 */
export const listCalendars = async ( options?: Parameters<typeof http>[1]): Promise<listCalendarsResponse> => {

  return http<listCalendarsResponse>(getListCalendarsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCalendarsQueryKey = () => {
    return [
    `/api/calendars`
    ] as const;
    }


export const getListCalendarsQueryOptions = <TData = Awaited<ReturnType<typeof listCalendars>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCalendarsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendars>>> = ({ signal }) => listCalendars({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCalendarsQueryResult = NonNullable<Awaited<ReturnType<typeof listCalendars>>>
export type ListCalendarsQueryError = unknown


export function useListCalendars<TData = Awaited<ReturnType<typeof listCalendars>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCalendars>>,
          TError,
          Awaited<ReturnType<typeof listCalendars>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCalendars<TData = Awaited<ReturnType<typeof listCalendars>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCalendars>>,
          TError,
          Awaited<ReturnType<typeof listCalendars>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCalendars<TData = Awaited<ReturnType<typeof listCalendars>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List settlement calendars
 */

export function useListCalendars<TData = Awaited<ReturnType<typeof listCalendars>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendars>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCalendarsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listCardsResponse200 = {
  data: CreditCard[]
  status: 200
}

export type listCardsResponseSuccess = (listCardsResponse200) & {
  headers: Headers;
};
;

export type listCardsResponse = (listCardsResponseSuccess)

export const getListCardsUrl = () => {




  return `/api/cards`
}

/**
 * Each entry carries the next few dates money will actually leave the paying account, with the statement-to-payment chain and business-day convention already resolved.
 * @summary List credit cards
 */
export const listCards = async ( options?: Parameters<typeof http>[1]): Promise<listCardsResponse> => {

  return http<listCardsResponse>(getListCardsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCardsQueryKey = () => {
    return [
    `/api/cards`
    ] as const;
    }


export const getListCardsQueryOptions = <TData = Awaited<ReturnType<typeof listCards>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCards>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCardsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCards>>> = ({ signal }) => listCards({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCardsQueryResult = NonNullable<Awaited<ReturnType<typeof listCards>>>
export type ListCardsQueryError = unknown


export function useListCards<TData = Awaited<ReturnType<typeof listCards>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCards>>,
          TError,
          Awaited<ReturnType<typeof listCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCards<TData = Awaited<ReturnType<typeof listCards>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCards>>,
          TError,
          Awaited<ReturnType<typeof listCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCards<TData = Awaited<ReturnType<typeof listCards>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCards>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List credit cards
 */

export function useListCards<TData = Awaited<ReturnType<typeof listCards>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCards>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCardsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createCardResponse201 = {
  data: CreditCard[]
  status: 201
}

export type createCardResponse400 = {
  data: void
  status: 400
}

export type createCardResponse409 = {
  data: void
  status: 409
}

export type createCardResponseSuccess = (createCardResponse201) & {
  headers: Headers;
};
export type createCardResponseError = (createCardResponse400 | createCardResponse409) & {
  headers: Headers;
};

export type createCardResponse = (createCardResponseSuccess | createCardResponseError)

export const getCreateCardUrl = () => {




  return `/api/cards`
}

/**
 * @summary Create a credit card
 */
export const createCard = async (creditCardInput: CreditCardInput, options?: Parameters<typeof http>[1]): Promise<createCardResponse> => {

  return http<createCardResponse>(getCreateCardUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(creditCardInput)
  }
);}





export const getCreateCardMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCard>>, TError,{data: CreditCardInput}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof createCard>>, TError,{data: CreditCardInput}, TContext> => {

const mutationKey = ['createCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCard>>, {data: CreditCardInput}> = (props) => {
          const {data} = props ?? {};

          return  createCard(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCardMutationResult = NonNullable<Awaited<ReturnType<typeof createCard>>>
    export type CreateCardMutationBody = CreditCardInput
    export type CreateCardMutationError = void

    /**
 * @summary Create a credit card
 */
export const useCreateCard = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCard>>, TError,{data: CreditCardInput}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCard>>,
        TError,
        {data: CreditCardInput},
        TContext
      > => {
      return useMutation(getCreateCardMutationOptions(options), queryClient);
    }

export type deleteCardResponse204 = {
  data: void
  status: 204
}

export type deleteCardResponse404 = {
  data: void
  status: 404
}

export type deleteCardResponseSuccess = (deleteCardResponse204) & {
  headers: Headers;
};
export type deleteCardResponseError = (deleteCardResponse404) & {
  headers: Headers;
};

export type deleteCardResponse = (deleteCardResponseSuccess | deleteCardResponseError)

export const getDeleteCardUrl = (id: string,) => {




  return `/api/cards/${id}`
}

/**
 * @summary Delete a credit card
 */
export const deleteCard = async (id: string, options?: Parameters<typeof http>[1]): Promise<deleteCardResponse> => {

  return http<deleteCardResponse>(getDeleteCardUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCardMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCard>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCard(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCardMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCard>>>

    export type DeleteCardMutationError = void

    /**
 * @summary Delete a credit card
 */
export const useDeleteCard = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCard>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteCardMutationOptions(options), queryClient);
    }

export type replaceCardResponse200 = {
  data: CreditCard[]
  status: 200
}

export type replaceCardResponse400 = {
  data: void
  status: 400
}

export type replaceCardResponse404 = {
  data: void
  status: 404
}

export type replaceCardResponseSuccess = (replaceCardResponse200) & {
  headers: Headers;
};
export type replaceCardResponseError = (replaceCardResponse400 | replaceCardResponse404) & {
  headers: Headers;
};

export type replaceCardResponse = (replaceCardResponseSuccess | replaceCardResponseError)

export const getReplaceCardUrl = (id: string,) => {




  return `/api/cards/${id}`
}

/**
 * @summary Replace a credit card
 */
export const replaceCard = async (id: string,
    creditCardInput: CreditCardInput, options?: Parameters<typeof http>[1]): Promise<replaceCardResponse> => {

  return http<replaceCardResponse>(getReplaceCardUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(creditCardInput)
  }
);}





export const getReplaceCardMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceCard>>, TError,{id: string;data: CreditCardInput}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceCard>>, TError,{id: string;data: CreditCardInput}, TContext> => {

const mutationKey = ['replaceCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceCard>>, {id: string;data: CreditCardInput}> = (props) => {
          const {id,data} = props ?? {};

          return  replaceCard(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceCardMutationResult = NonNullable<Awaited<ReturnType<typeof replaceCard>>>
    export type ReplaceCardMutationBody = CreditCardInput
    export type ReplaceCardMutationError = void

    /**
 * @summary Replace a credit card
 */
export const useReplaceCard = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceCard>>, TError,{id: string;data: CreditCardInput}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceCard>>,
        TError,
        {id: string;data: CreditCardInput},
        TContext
      > => {
      return useMutation(getReplaceCardMutationOptions(options), queryClient);
    }

export type listCashFlowsResponse200 = {
  data: CashFlow[]
  status: 200
}

export type listCashFlowsResponseSuccess = (listCashFlowsResponse200) & {
  headers: Headers;
};
;

export type listCashFlowsResponse = (listCashFlowsResponseSuccess)

export const getListCashFlowsUrl = () => {




  return `/api/cash-flows`
}

/**
 * Each entry carries the next few dates it will actually land on, with the business-day convention already applied.
 * @summary List all cash flows
 */
export const listCashFlows = async ( options?: Parameters<typeof http>[1]): Promise<listCashFlowsResponse> => {

  return http<listCashFlowsResponse>(getListCashFlowsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCashFlowsQueryKey = () => {
    return [
    `/api/cash-flows`
    ] as const;
    }


export const getListCashFlowsQueryOptions = <TData = Awaited<ReturnType<typeof listCashFlows>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCashFlows>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCashFlowsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCashFlows>>> = ({ signal }) => listCashFlows({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCashFlows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCashFlowsQueryResult = NonNullable<Awaited<ReturnType<typeof listCashFlows>>>
export type ListCashFlowsQueryError = unknown


export function useListCashFlows<TData = Awaited<ReturnType<typeof listCashFlows>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCashFlows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCashFlows>>,
          TError,
          Awaited<ReturnType<typeof listCashFlows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCashFlows<TData = Awaited<ReturnType<typeof listCashFlows>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCashFlows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCashFlows>>,
          TError,
          Awaited<ReturnType<typeof listCashFlows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCashFlows<TData = Awaited<ReturnType<typeof listCashFlows>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCashFlows>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all cash flows
 */

export function useListCashFlows<TData = Awaited<ReturnType<typeof listCashFlows>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCashFlows>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCashFlowsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createCashFlowResponse201 = {
  data: CashFlow
  status: 201
}

export type createCashFlowResponse400 = {
  data: void
  status: 400
}

export type createCashFlowResponse409 = {
  data: void
  status: 409
}

export type createCashFlowResponseSuccess = (createCashFlowResponse201) & {
  headers: Headers;
};
export type createCashFlowResponseError = (createCashFlowResponse400 | createCashFlowResponse409) & {
  headers: Headers;
};

export type createCashFlowResponse = (createCashFlowResponseSuccess | createCashFlowResponseError)

export const getCreateCashFlowUrl = () => {




  return `/api/cash-flows`
}

/**
 * The id is chosen by the caller and must be unique for this user.
 * @summary Create a cash flow
 */
export const createCashFlow = async (cashFlowInput: CashFlowInput, options?: Parameters<typeof http>[1]): Promise<createCashFlowResponse> => {

  return http<createCashFlowResponse>(getCreateCashFlowUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cashFlowInput)
  }
);}





export const getCreateCashFlowMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCashFlow>>, TError,{data: CashFlowInput}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof createCashFlow>>, TError,{data: CashFlowInput}, TContext> => {

const mutationKey = ['createCashFlow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCashFlow>>, {data: CashFlowInput}> = (props) => {
          const {data} = props ?? {};

          return  createCashFlow(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCashFlowMutationResult = NonNullable<Awaited<ReturnType<typeof createCashFlow>>>
    export type CreateCashFlowMutationBody = CashFlowInput
    export type CreateCashFlowMutationError = void

    /**
 * @summary Create a cash flow
 */
export const useCreateCashFlow = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCashFlow>>, TError,{data: CashFlowInput}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCashFlow>>,
        TError,
        {data: CashFlowInput},
        TContext
      > => {
      return useMutation(getCreateCashFlowMutationOptions(options), queryClient);
    }

export type deleteCashFlowResponse204 = {
  data: void
  status: 204
}

export type deleteCashFlowResponse404 = {
  data: void
  status: 404
}

export type deleteCashFlowResponseSuccess = (deleteCashFlowResponse204) & {
  headers: Headers;
};
export type deleteCashFlowResponseError = (deleteCashFlowResponse404) & {
  headers: Headers;
};

export type deleteCashFlowResponse = (deleteCashFlowResponseSuccess | deleteCashFlowResponseError)

export const getDeleteCashFlowUrl = (id: string,) => {




  return `/api/cash-flows/${id}`
}

/**
 * @summary Delete a cash flow
 */
export const deleteCashFlow = async (id: string, options?: Parameters<typeof http>[1]): Promise<deleteCashFlowResponse> => {

  return http<deleteCashFlowResponse>(getDeleteCashFlowUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCashFlowMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCashFlow>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCashFlow>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCashFlow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCashFlow>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCashFlow(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCashFlowMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCashFlow>>>

    export type DeleteCashFlowMutationError = void

    /**
 * @summary Delete a cash flow
 */
export const useDeleteCashFlow = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCashFlow>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCashFlow>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteCashFlowMutationOptions(options), queryClient);
    }

export type replaceCashFlowResponse200 = {
  data: CashFlow
  status: 200
}

export type replaceCashFlowResponse400 = {
  data: void
  status: 400
}

export type replaceCashFlowResponse404 = {
  data: void
  status: 404
}

export type replaceCashFlowResponseSuccess = (replaceCashFlowResponse200) & {
  headers: Headers;
};
export type replaceCashFlowResponseError = (replaceCashFlowResponse400 | replaceCashFlowResponse404) & {
  headers: Headers;
};

export type replaceCashFlowResponse = (replaceCashFlowResponseSuccess | replaceCashFlowResponseError)

export const getReplaceCashFlowUrl = (id: string,) => {




  return `/api/cash-flows/${id}`
}

/**
 * The id in the path wins; any id in the body is ignored.
 * @summary Replace a cash flow
 */
export const replaceCashFlow = async (id: string,
    cashFlowInput: CashFlowInput, options?: Parameters<typeof http>[1]): Promise<replaceCashFlowResponse> => {

  return http<replaceCashFlowResponse>(getReplaceCashFlowUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cashFlowInput)
  }
);}





export const getReplaceCashFlowMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceCashFlow>>, TError,{id: string;data: CashFlowInput}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceCashFlow>>, TError,{id: string;data: CashFlowInput}, TContext> => {

const mutationKey = ['replaceCashFlow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceCashFlow>>, {id: string;data: CashFlowInput}> = (props) => {
          const {id,data} = props ?? {};

          return  replaceCashFlow(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceCashFlowMutationResult = NonNullable<Awaited<ReturnType<typeof replaceCashFlow>>>
    export type ReplaceCashFlowMutationBody = CashFlowInput
    export type ReplaceCashFlowMutationError = void

    /**
 * @summary Replace a cash flow
 */
export const useReplaceCashFlow = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceCashFlow>>, TError,{id: string;data: CashFlowInput}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceCashFlow>>,
        TError,
        {id: string;data: CashFlowInput},
        TContext
      > => {
      return useMutation(getReplaceCashFlowMutationOptions(options), queryClient);
    }

export type getHealthResponse200 = {
  data: Health
  status: 200
}

export type getHealthResponseSuccess = (getHealthResponse200) & {
  headers: Headers;
};
;

export type getHealthResponse = (getHealthResponseSuccess)

export const getGetHealthUrl = () => {




  return `/api/health`
}

/**
 * Returns service status and the identity of the running build. Used by the P0 pipeline check to prove controller -> contract -> TypeScript client generation end to end.
 * @summary Liveness and build identity
 */
export const getHealth = async ( options?: Parameters<typeof http>[1]): Promise<getHealthResponse> => {

  return http<getHealthResponse>(getGetHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHealthQueryKey = () => {
    return [
    `/api/health`
    ] as const;
    }


export const getGetHealthQueryOptions = <TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({ signal }) => getHealth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getHealth>>>
export type GetHealthQueryError = unknown


export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Liveness and build identity
 */

export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listLoansResponse200 = {
  data: ConsumerLoan[]
  status: 200
}

export type listLoansResponseSuccess = (listLoansResponse200) & {
  headers: Headers;
};
;

export type listLoansResponse = (listLoansResponseSuccess)

export const getListLoansUrl = () => {




  return `/api/loans`
}

/**
 * Each entry carries its payoff date and how many instalments remain, both resolved from the schedule rather than left to the client to work out.
 * @summary List consumer loans
 */
export const listLoans = async ( options?: Parameters<typeof http>[1]): Promise<listLoansResponse> => {

  return http<listLoansResponse>(getListLoansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLoansQueryKey = () => {
    return [
    `/api/loans`
    ] as const;
    }


export const getListLoansQueryOptions = <TData = Awaited<ReturnType<typeof listLoans>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLoans>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLoansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLoans>>> = ({ signal }) => listLoans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLoans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLoansQueryResult = NonNullable<Awaited<ReturnType<typeof listLoans>>>
export type ListLoansQueryError = unknown


export function useListLoans<TData = Awaited<ReturnType<typeof listLoans>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLoans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLoans>>,
          TError,
          Awaited<ReturnType<typeof listLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLoans<TData = Awaited<ReturnType<typeof listLoans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLoans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLoans>>,
          TError,
          Awaited<ReturnType<typeof listLoans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLoans<TData = Awaited<ReturnType<typeof listLoans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLoans>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List consumer loans
 */

export function useListLoans<TData = Awaited<ReturnType<typeof listLoans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLoans>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLoansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createLoanResponse201 = {
  data: ConsumerLoan[]
  status: 201
}

export type createLoanResponse400 = {
  data: void
  status: 400
}

export type createLoanResponse409 = {
  data: void
  status: 409
}

export type createLoanResponseSuccess = (createLoanResponse201) & {
  headers: Headers;
};
export type createLoanResponseError = (createLoanResponse400 | createLoanResponse409) & {
  headers: Headers;
};

export type createLoanResponse = (createLoanResponseSuccess | createLoanResponseError)

export const getCreateLoanUrl = () => {




  return `/api/loans`
}

/**
 * The schedule must end: a loan has a payoff date, and one that never finishes would subtract from every projection for ever.
 * @summary Create a consumer loan
 */
export const createLoan = async (consumerLoanInput: ConsumerLoanInput, options?: Parameters<typeof http>[1]): Promise<createLoanResponse> => {

  return http<createLoanResponse>(getCreateLoanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(consumerLoanInput)
  }
);}





export const getCreateLoanMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLoan>>, TError,{data: ConsumerLoanInput}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof createLoan>>, TError,{data: ConsumerLoanInput}, TContext> => {

const mutationKey = ['createLoan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLoan>>, {data: ConsumerLoanInput}> = (props) => {
          const {data} = props ?? {};

          return  createLoan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLoanMutationResult = NonNullable<Awaited<ReturnType<typeof createLoan>>>
    export type CreateLoanMutationBody = ConsumerLoanInput
    export type CreateLoanMutationError = void

    /**
 * @summary Create a consumer loan
 */
export const useCreateLoan = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLoan>>, TError,{data: ConsumerLoanInput}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLoan>>,
        TError,
        {data: ConsumerLoanInput},
        TContext
      > => {
      return useMutation(getCreateLoanMutationOptions(options), queryClient);
    }

export type deleteLoanResponse204 = {
  data: void
  status: 204
}

export type deleteLoanResponse404 = {
  data: void
  status: 404
}

export type deleteLoanResponseSuccess = (deleteLoanResponse204) & {
  headers: Headers;
};
export type deleteLoanResponseError = (deleteLoanResponse404) & {
  headers: Headers;
};

export type deleteLoanResponse = (deleteLoanResponseSuccess | deleteLoanResponseError)

export const getDeleteLoanUrl = (id: string,) => {




  return `/api/loans/${id}`
}

/**
 * The schedule it owned goes with it.
 * @summary Delete a consumer loan
 */
export const deleteLoan = async (id: string, options?: Parameters<typeof http>[1]): Promise<deleteLoanResponse> => {

  return http<deleteLoanResponse>(getDeleteLoanUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteLoanMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLoan>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLoan>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteLoan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLoan>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLoan(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLoanMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLoan>>>

    export type DeleteLoanMutationError = void

    /**
 * @summary Delete a consumer loan
 */
export const useDeleteLoan = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLoan>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLoan>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteLoanMutationOptions(options), queryClient);
    }

export type replaceLoanResponse200 = {
  data: ConsumerLoan[]
  status: 200
}

export type replaceLoanResponse400 = {
  data: void
  status: 400
}

export type replaceLoanResponse404 = {
  data: void
  status: 404
}

export type replaceLoanResponseSuccess = (replaceLoanResponse200) & {
  headers: Headers;
};
export type replaceLoanResponseError = (replaceLoanResponse400 | replaceLoanResponse404) & {
  headers: Headers;
};

export type replaceLoanResponse = (replaceLoanResponseSuccess | replaceLoanResponseError)

export const getReplaceLoanUrl = (id: string,) => {




  return `/api/loans/${id}`
}

/**
 * @summary Replace a consumer loan
 */
export const replaceLoan = async (id: string,
    consumerLoanInput: ConsumerLoanInput, options?: Parameters<typeof http>[1]): Promise<replaceLoanResponse> => {

  return http<replaceLoanResponse>(getReplaceLoanUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(consumerLoanInput)
  }
);}





export const getReplaceLoanMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceLoan>>, TError,{id: string;data: ConsumerLoanInput}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceLoan>>, TError,{id: string;data: ConsumerLoanInput}, TContext> => {

const mutationKey = ['replaceLoan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceLoan>>, {id: string;data: ConsumerLoanInput}> = (props) => {
          const {id,data} = props ?? {};

          return  replaceLoan(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceLoanMutationResult = NonNullable<Awaited<ReturnType<typeof replaceLoan>>>
    export type ReplaceLoanMutationBody = ConsumerLoanInput
    export type ReplaceLoanMutationError = void

    /**
 * @summary Replace a consumer loan
 */
export const useReplaceLoan = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceLoan>>, TError,{id: string;data: ConsumerLoanInput}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceLoan>>,
        TError,
        {id: string;data: ConsumerLoanInput},
        TContext
      > => {
      return useMutation(getReplaceLoanMutationOptions(options), queryClient);
    }

export type getMeResponse200 = {
  data: Me
  status: 200
}

export type getMeResponse401 = {
  data: void
  status: 401
}

export type getMeResponse403 = {
  data: void
  status: 403
}

export type getMeResponseSuccess = (getMeResponse200) & {
  headers: Headers;
};
export type getMeResponseError = (getMeResponse401 | getMeResponse403) & {
  headers: Headers;
};

export type getMeResponse = (getMeResponseSuccess | getMeResponseError)

export const getGetMeUrl = () => {




  return `/api/me`
}

/**
 * Also the first request a client should make: reaching any endpoint is what creates the user and their plan on first sign-in, so everything afterwards has something to read.
 * @summary The signed-in user
 */
export const getMe = async ( options?: Parameters<typeof http>[1]): Promise<getMeResponse> => {

  return http<getMeResponse>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = void


export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The signed-in user
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getProjectionResponse200 = {
  data: Projection
  status: 200
}

export type getProjectionResponse400 = {
  data: void
  status: 400
}

export type getProjectionResponseSuccess = (getProjectionResponse200) & {
  headers: Headers;
};
export type getProjectionResponseError = (getProjectionResponse400) & {
  headers: Headers;
};

export type getProjectionResponse = (getProjectionResponseSuccess | getProjectionResponseError)

export const getGetProjectionUrl = (params?: GetProjectionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/projection?${stringifiedParams}` : `/api/projection`
}

/**
 * Rolls every account forward from its most recent balance anchor, applying scheduled cash flows, card payments, loan instalments and interest accrual, and reports where any account falls below zero or below its buffer.
 *
 * Balances are per account in that account's own currency and are never converted; only the portfolio total is expressed in the reporting currency. A healthy total does not imply solvency — check `solvent` on each account.
 *
 * The clock is read here, not in the engine: the engine is a pure function of the as-of date it is given.
 * @summary Project balances over a horizon
 */
export const getProjection = async (params?: GetProjectionParams, options?: Parameters<typeof http>[1]): Promise<getProjectionResponse> => {

  return http<getProjectionResponse>(getGetProjectionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProjectionQueryKey = (params?: GetProjectionParams,) => {
    return [
    `/api/projection`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProjectionQueryOptions = <TData = Awaited<ReturnType<typeof getProjection>>, TError = void>(params?: GetProjectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjection>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjection>>> = ({ signal }) => getProjection(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectionQueryResult = NonNullable<Awaited<ReturnType<typeof getProjection>>>
export type GetProjectionQueryError = void


export function useGetProjection<TData = Awaited<ReturnType<typeof getProjection>>, TError = void>(
 params: undefined |  GetProjectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjection>>,
          TError,
          Awaited<ReturnType<typeof getProjection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjection<TData = Awaited<ReturnType<typeof getProjection>>, TError = void>(
 params?: GetProjectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjection>>,
          TError,
          Awaited<ReturnType<typeof getProjection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjection<TData = Awaited<ReturnType<typeof getProjection>>, TError = void>(
 params?: GetProjectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjection>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Project balances over a horizon
 */

export function useGetProjection<TData = Awaited<ReturnType<typeof getProjection>>, TError = void>(
 params?: GetProjectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjection>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getReconciliationResponse200 = {
  data: Reconciliation
  status: 200
}

export type getReconciliationResponseSuccess = (getReconciliationResponse200) & {
  headers: Headers;
};
;

export type getReconciliationResponse = (getReconciliationResponseSuccess)

export const getGetReconciliationUrl = () => {




  return `/api/reconciliation`
}

/**
 * Pending items are movements the rules predicted for a date that has already passed and which nothing has superseded — the projection engine excludes anything already recorded, so an item disappears from this list once it is reconciled.
 *
 * Drift compares each realized movement against the rule that predicted it. Overrides and skips are deliberate decisions rather than surprises, so they are excluded; so are ad-hoc movements, which no rule predicted.
 * @summary What has come due, what has been recorded, and how far the rules have drifted
 */
export const getReconciliation = async ( options?: Parameters<typeof http>[1]): Promise<getReconciliationResponse> => {

  return http<getReconciliationResponse>(getGetReconciliationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReconciliationQueryKey = () => {
    return [
    `/api/reconciliation`
    ] as const;
    }


export const getGetReconciliationQueryOptions = <TData = Awaited<ReturnType<typeof getReconciliation>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReconciliation>>, TError, TData>>, request?: SecondParameter<typeof http>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReconciliationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReconciliation>>> = ({ signal }) => getReconciliation({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReconciliation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReconciliationQueryResult = NonNullable<Awaited<ReturnType<typeof getReconciliation>>>
export type GetReconciliationQueryError = unknown


export function useGetReconciliation<TData = Awaited<ReturnType<typeof getReconciliation>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReconciliation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReconciliation>>,
          TError,
          Awaited<ReturnType<typeof getReconciliation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReconciliation<TData = Awaited<ReturnType<typeof getReconciliation>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReconciliation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReconciliation>>,
          TError,
          Awaited<ReturnType<typeof getReconciliation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReconciliation<TData = Awaited<ReturnType<typeof getReconciliation>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReconciliation>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What has come due, what has been recorded, and how far the rules have drifted
 */

export function useGetReconciliation<TData = Awaited<ReturnType<typeof getReconciliation>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReconciliation>>, TError, TData>>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReconciliationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type recordOccurrenceResponse201 = {
  data: Recording
  status: 201
}

export type recordOccurrenceResponse400 = {
  data: void
  status: 400
}

export type recordOccurrenceResponseSuccess = (recordOccurrenceResponse201) & {
  headers: Headers;
};
export type recordOccurrenceResponseError = (recordOccurrenceResponse400) & {
  headers: Headers;
};

export type recordOccurrenceResponse = (recordOccurrenceResponseSuccess | recordOccurrenceResponseError)

export const getRecordOccurrenceUrl = () => {




  return `/api/reconciliation`
}

/**
 * A realized movement follows reality for both date and amount; an override pins a future instance; a skip suppresses one. All three supersede whatever the rule would otherwise have projected.
 * @summary Record what actually happened
 */
export const recordOccurrence = async (recordingInput: RecordingInput, options?: Parameters<typeof http>[1]): Promise<recordOccurrenceResponse> => {

  return http<recordOccurrenceResponse>(getRecordOccurrenceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recordingInput)
  }
);}





export const getRecordOccurrenceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordOccurrence>>, TError,{data: RecordingInput}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof recordOccurrence>>, TError,{data: RecordingInput}, TContext> => {

const mutationKey = ['recordOccurrence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordOccurrence>>, {data: RecordingInput}> = (props) => {
          const {data} = props ?? {};

          return  recordOccurrence(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordOccurrenceMutationResult = NonNullable<Awaited<ReturnType<typeof recordOccurrence>>>
    export type RecordOccurrenceMutationBody = RecordingInput
    export type RecordOccurrenceMutationError = void

    /**
 * @summary Record what actually happened
 */
export const useRecordOccurrence = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordOccurrence>>, TError,{data: RecordingInput}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordOccurrence>>,
        TError,
        {data: RecordingInput},
        TContext
      > => {
      return useMutation(getRecordOccurrenceMutationOptions(options), queryClient);
    }

export type deleteRecordingResponse204 = {
  data: void
  status: 204
}

export type deleteRecordingResponse404 = {
  data: void
  status: 404
}

export type deleteRecordingResponseSuccess = (deleteRecordingResponse204) & {
  headers: Headers;
};
export type deleteRecordingResponseError = (deleteRecordingResponse404) & {
  headers: Headers;
};

export type deleteRecordingResponse = (deleteRecordingResponseSuccess | deleteRecordingResponseError)

export const getDeleteRecordingUrl = (id: string,) => {




  return `/api/reconciliation/${id}`
}

/**
 * Restores whatever the rule would have projected. Worth having: a recording supersedes a projection, so a mistyped amount rewrites history until it is taken back.
 * @summary Undo a recording
 */
export const deleteRecording = async (id: string, options?: Parameters<typeof http>[1]): Promise<deleteRecordingResponse> => {

  return http<deleteRecordingResponse>(getDeleteRecordingUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteRecordingMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRecording>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRecording>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteRecording'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRecording>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteRecording(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRecordingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRecording>>>

    export type DeleteRecordingMutationError = void

    /**
 * @summary Undo a recording
 */
export const useDeleteRecording = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRecording>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof http>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRecording>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteRecordingMutationOptions(options), queryClient);
    }
